import CompanySnapshotRow from 'components/global/CompanySnapShotRow';
import Loadable from 'components/global/Loadable';
import SimpleCard from 'components/global/SimpleCard';
import { $detail } from 'signals/global.signals';
import { formatMoneyShorthand } from 'utils/formatMoney';

const FounderRoomDetail = () => (
  <SimpleCard>
    <Loadable signal={$detail}>
      <CompanySnapshotRow label="Room Name" value={$detail.value.name} />
      <CompanySnapshotRow label="Description" value={$detail.value.description} />
      <CompanySnapshotRow label="Type of Raise" value={$detail.value.deal?.typeOfRaise} />
      <CompanySnapshotRow label="Investment Stage" value={$detail.value.deal?.investmentStage} />
      <CompanySnapshotRow label="Current Raise Size" value={formatMoneyShorthand($detail.value.deal?.currentRaiseSize)} />
      <CompanySnapshotRow label="Amount Committed" value={formatMoneyShorthand($detail.value.deal?.amountCommitted)} />
      <CompanySnapshotRow label="Amount Previously Raised" value={formatMoneyShorthand($detail.value.deal?.amountPreviouslyRaised)} />
      <CompanySnapshotRow label="Minimum Investment" value={$detail.value.deal?.minimumInvestment ? formatMoneyShorthand($detail.value.deal?.minimumInvestment) : 'Not specified'} />
      <CompanySnapshotRow label="Pre-Money Valuation" value={$detail.value?.preMoneyValuation ? formatMoneyShorthand($detail.value?.preMoneyValuation) : 'Not specified'} />
      <CompanySnapshotRow label="Cap" value={formatMoneyShorthand($detail.value?.cap)} />
      <CompanySnapshotRow label="Discount Percent" value={$detail.value?.discountPercent ? `${$detail.value?.discountPercent}%` : 'None'} />
      <CompanySnapshotRow label="Interest Rate" value={$detail.value?.interestRate ? `${$detail.value?.interestRate}%` : 'None'} />
      <CompanySnapshotRow label="Uses of Capital" value={$detail.value?.usesOfCapital} />
    </Loadable>
  </SimpleCard>
);

export default FounderRoomDetail;
